/* eslint-disable import/prefer-default-export */
export const SET_RPM_RANGES_LIST = 'SET_RPM_RANGES_LIST';
export const SET_HOURMETER_LIMITS_LIST = 'SET_HOURMETER_LIMITS_LIST';
